import React from 'react';
import { ConfirmationDialog } from '../../../components/common/ConfirmationDialog';
import { useLanguage } from '../../../features/language/useLanguage';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    count: number;
    isDeleting: boolean;
}

export const ArtisanDeleteDialog: React.FC<Props> = ({ isOpen, onClose, onConfirm, count, isDeleting }) => {
    const { t } = useLanguage();

    return (
        <ConfirmationDialog
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title={t('artisanSync.delete.title')}
            message={t('artisanSync.delete.message', { count })}
            confirmLabel={isDeleting ? t('artisanSync.delete.deleting') : t('artisanSync.delete.action')}
            isDestructive
        />
    );
};
